export const isMobile = /iPhone|iPad|iPod|Android|blackberry|blazer/i.test(navigator.userAgent);
